import type { MeetingBucket } from '@wundo/shared/calendar.ts';
import { ALL_BUCKETS, DEFAULT_BUCKETS } from '@/components/agenda/agendaFilter.ts';

/*
 * Which drawers of the agenda show, remembered in this browser. Storage can
 * throw in a locked-down browser, and anything unreadable falls back to the
 * conversations, so a broken value never empties the week.
 */

const STORAGE_KEY = 'wundo.agenda.buckets';

export function storedAgendaBuckets(): readonly MeetingBucket[] {
  try {
    const parsed: unknown = JSON.parse(
      window.localStorage.getItem(STORAGE_KEY) ?? 'null',
    );
    if (!Array.isArray(parsed)) return DEFAULT_BUCKETS;
    return ALL_BUCKETS.filter((bucket) => parsed.includes(bucket));
  } catch {
    return DEFAULT_BUCKETS;
  }
}

export function storeAgendaBuckets(buckets: readonly MeetingBucket[]): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(buckets));
  } catch {
    /* Kept for this visit only. */
  }
}
